import {
  WireCoverageOption,
  WireCoverageOptionType,
} from 'scenes/common/api/quote/types';
import { getAvailableExtras } from 'scenes/motor/helpers/OptionalExtras/getAvailableExtras';
import { getIncludedExtras } from 'scenes/motor/selectors';
import {
  MotorFunnelState,
  MotorInsuranceType,
  OptionalExtra,
} from 'scenes/motor/types';

export const toOptionalExtra = (
  option: WireCoverageOptionType
): OptionalExtra => {
  switch (option) {
    case WireCoverageOptionType.HireCar:
      return OptionalExtra.HireCar;
    case WireCoverageOptionType.RoadSide:
      return OptionalExtra.RoadSide;
    case WireCoverageOptionType.Under25:
      return OptionalExtra.Under25;
    case WireCoverageOptionType.WindScreen:
      return OptionalExtra.WindScreen;
    default:
      return OptionalExtra.Unspecified;
  }
};

export const toWireOptions = (
  state: MotorFunnelState,
  insuranceType: MotorInsuranceType,
  extras: string[]
): WireCoverageOption[] => [
  {
    name: WireCoverageOptionType.Under25,
    value:
      extras.includes(OptionalExtra.Under25) ||
      getIncludedExtras(state).includes(OptionalExtra.Under25) ||
      insuranceType === MotorInsuranceType.ThirdParty,
  },
  ...[
    WireCoverageOptionType.WindScreen,
    WireCoverageOptionType.HireCar,
    WireCoverageOptionType.RoadSide,
  ].map((option) => ({
    name: option,
    value:
      getAvailableExtras(insuranceType).some(
        (extra) => extra.code === toOptionalExtra(option)
      ) &&
      [...extras, ...getIncludedExtras(state)].includes(
        toOptionalExtra(option)
      ),
  })),
];
